// extracted by mini-css-extract-plugin
export default {"headerRow":"headerRow--_TU0Y","buttonRow":"buttonRow--kCEOX","commentEntry":"commentEntry--nSeJx","saveCommentButton":"saveCommentButton--GoCml"};